import React from 'react';
import QueryDetails from './querydetails';
import QueryTable from './querytable';
import './querymanagement.css';

const ShowTablePage = () => {
  return (
    <main className="ca-query-management-page">
      <QueryDetails />
      <QueryTable />
    </main>
  );
};

export default ShowTablePage;